import { ReactNode } from 'react'
import { Grid, Text } from '@/components'
import AlertMessage from '../AlertMessage'
import { useNavigation } from '@/app/hooks'
import toExternalLink from '@/utils/to-external-link'

export interface Props {
  className?: string
  mode: 'info' | 'error' | 'warning'
  children?: ReactNode
  linkText?: string
  reconnectUrl?: string
  reconnectAction?: () => void
  deviceName: string
  newTab?: boolean
  show?: boolean
}

export default function DeviceAuthAlertMessage(props: Props) {
  const navigation = useNavigation()
  const { reconnectUrl, reconnectAction, linkText } = props

  const canNavigate = reconnectUrl || reconnectAction || linkText

  const navigate = () => {
    if (reconnectAction) {
      return reconnectAction()
    }
    if (reconnectUrl) {
      if (reconnectUrl.startsWith('http')) {
        return window.open(toExternalLink(reconnectUrl), '_blank')
      } else {
        return navigation.push(reconnectUrl)
      }
    }
    if (linkText) {
      return navigation.push('/connect-device/')
    }
    return undefined
  }

  return (
    <AlertMessage
      className={props.className}
      variant={props.mode}
      show={props.show}
    >
      <Grid flow="row" gap="12px">
        {props.children
          ? props.children
          : `Oops! We're having trouble communicating with your ${props.deviceName}.`}
        {canNavigate ? (
          <Text variant="link" onClick={navigate}>
            {props.linkText ? props.linkText : 'Reconnect'}
          </Text>
        ) : null}
      </Grid>
    </AlertMessage>
  )
}
